jQuery(document).ready(function($){
  //open reviews tab when reviews clicked
  $(document).on('click', '.yotpo.bottomLine.yotpo-reviews', function(e) {
    if ( $('.tabs li a[data-for="reviews"]') ) {
      $('.tabs li a[data-for="reviews"]').trigger('click');
      $([document.documentElement, document.body]).animate({
        scrollTop: $('.tabs li a[data-for="reviews"]').offset().top - 100
      }, 800); 
    }
    
  });
  $(document).on('click', '.yotpo.bottomLine.mobile-yotpo-reviews', function(e) {   
    if ($('button[data-for="reviews"]')) {
      console.log('mobile reviews');
      $('button[data-for="reviews"]').trigger('click');
      $([document.documentElement, document.body]).animate({
        scrollTop: $('button[data-for="reviews"]').offset().top - 100
      }, 800); 
    }
    
  });
  
  //collection list filter dropdown
  $('.sidebar__collection-filter .toggle').on('click', function(e) {
    console.log('filter');
    if ($(window).width() > 798) {
      if ($(this).find('span').hasClass('icon-up-arrow')) {
        $(this).find('span').removeClass('icon-up-arrow');
        $(this).find('span').addClass('icon-down-arrow');
      }else if ($(this).find('span').hasClass('icon-down-arrow')) {
        $(this).find('span').removeClass('icon-down-arrow');
        $(this).find('span').addClass('icon-up-arrow');
      }
//       $(this).next('.toggle_list').slideToggle('slow');
    }
  });
  if ($(window).width() > 798) {
    $('.sidebar__collection-filter .toggle').find('.toggle_list').slideToggle('slow');
  }

  $('body.product-new-mobile .product_gallery_nav').flickity({
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    freeScroll: false,
    wrapAround: $('.product_gallery_nav .gallery-cell').length > 6 ? true : false,
    prevNextButtons: $('.product_gallery_nav .gallery-cell').length > 6 ? true : false,
    draggable: false,
    on: {
    	change: function(index) {
    		console.log(index);
          	$('.product_gallery_nav .gallery-cell').eq(index).trigger('click');
  		},
      	staticClick: function(event, pointer, element, index) {
        	$('.product_gallery_nav').flickity('select', index);
      	}
  	}
  });
  
  $('.js-recently-viewed .products-slider').flickity({
  	cellAlign: 'left',
    contain: true,
    pageDots: false,
    freeScroll: false,
    wrapAround: false,
    draggable: true,
  });

  $('.product-video-button').on('click', function(e) {
    var _this = this;
    $(this).next().show();
    setTimeout(function(){
      $(_this).next().find('.video-carousel').flickity({
        cellAlign: 'left',
        pageDots: false
      });

      $(_this).next().addClass('active');
    }, 100);
  });

  $('.jp-video-popup-close').on('click', function(e) {
    var _this = this;
    $(this).closest('.jp-video-popup').removeClass('active');
    setTimeout(function() {
      $(_this).closest('.jp-video-popup').hide();
      $(_this).closest('.jp-video-popup').find('.video-carousel').flickity('destroy');
    }, 100);
  });
  
  //JP Popover
  $('.jp-popover').on('click', function(e){
    $(this).fadeOut();
  });

  if ( $(window).width() <= 1024 ) {
    /* For topbanner css */
    window.timeElapsed = 0;
    window.topBannerCssTimer = setInterval(function() { 

      if($(document).find('#qab_container').length > 0 ) {
        // The Hextom bar sits in the page flow, so only pad the body if it's fixed;
        // padding a static bar counts its height twice and leaves a gap under the header
        var $qab = $(document).find('#qab_container');
        $('body').css('padding-top', $qab.css('position') === 'fixed' ? $qab.outerHeight() + 'px' : '0px');
        clearInterval(window.topBannerCssTimer); 
      } else { 
        window.timeElapsed++; 
      } 

      if(window.timeElapsed > 1000) { 
        clearInterval(window.topBannerCssTimer); 
      } 

    }, 100); 
  }

  if ( $(window).width() > 1024 ) {
    /* For topbanner css */
    $('.sticky_nav').css('top', '0px');
    console.log('windows width is greater than 1024');
    console.log($('.sticky_nav.sticky_nav--stick').length);
    window.timeElapsed = 0;
    window.topBannerCssTimer = setInterval(function() { if($(document).find('#qab_container').length > 0 ) { $('.sticky_nav').css('top', $(document).find('#qab_container').outerHeight() + 'px'); clearInterval(window.topBannerCssTimer); } else { window.timeElapsed++; } if(window.timeElapsed > 100) { clearInterval(window.topBannerCssTimer); } }, 1000); 
  }

  /* iPad Mega Menu */
  $('header .MainMenu a[data-mega-menu-target]').on('click', function(e) {

    console.log('Jack');

    if ( $(window).width() <= 1024 ) {

      e.preventDefault();

      var megaMenu = $(this).attr('data-mega-menu-target');

      $('header .MainMenu a[data-mega-menu-target]').removeClass('active_link');
      $(this).toggleClass('active_link');

      $(this).parents('header').find('.mega-menu').hide();

      if ( $(this).hasClass('active_link') ) {
        $(this).parents('header').find(megaMenu).show();
      } else {
        $(this).parents('header').find(megaMenu).hide();
      }

    }
  });

  /* Mobile menu */  
  $(document).on('click', '#mobile_menu > li.sublink > a.parent-link--true', function(e) {

    event.preventDefault ? event.preventDefault() : (event.returnValue = false);  

    $('body').addClass('is-active');

    if ( !$(this).hasClass('jp-active') ) {

      $(this).addClass('jp-active');

      $(this).find('.right.icon-down-arrow').trigger('click');

      //       $(this).parent('li').find('ul').slideToggle();

      return false;

    } else {

      window.location = $(this).attr('href');

      return false;

    }

  });

  $(document).on('click', '#mobile_menu > li > a .right.icon-down-arrow', function(e) {
    event.preventDefault ? event.preventDefault() : (event.returnValue = false);  
    return false;
  });

  /* Shopify Predictive Search */
  var timeout = null;
  $('input.search-terms').on("input", function(e) {

    var $this = $(this);
    var queryValue = $(this).val();

    clearTimeout(timeout);

    timeout = setTimeout(function() {
      if (queryValue.length > 0) {

        console.log(queryValue);

        $.ajax({
          url: "/search/suggest.json", 
          data: {
            "q": queryValue,
            "resources": {
              "type": "product",
              "limit": 5,
              "options": {
                "fields": "title,product_type,variants.title" 
              }
            }
          },
          async: true
        }).done(function(response) {
          var productSuggestions = response.resources.results.products;

          if ( productSuggestions.length > 0 ) {

            var resultHtml = "";

            $('body').find('.predictive-search-result').remove();

            resultHtml += "<ul class='predictive-search-result'>";

            $.each( productSuggestions, function(index, value) {

              resultHtml += "<li>" + "<a href='" + value.url + "'>" + '<img src="' + value.featured_image.url +  '">' + "<div class='result-info'>" + "<p>" + value.title + "</p>" + "<p>"+ Shopify.formatMoney(value.price) + "</p>" + "</div>" + "</a>" + "</li>";

            });

            resultHtml += "<li>" + "<a href='" + "/search?type=product&q=" + queryValue + "*'>" + "View All Result" + "</a>" + "</li>";

            resultHtml += "</ul>";

            $($this.closest('form.header_search_form')).append(resultHtml);

          } else {

            $('body').find('.predictive-search-result').remove();

          }
        }).fail(function(error) {

          $('body').find('.predictive-search-result').remove();

        }); 
      } else {

        $('body').find('.predictive-search-result').remove();

      }
    }, 500);

  });


  /* Add * Character to the End of Search Query String */
  $('form.header_search_form').on('submit', function(e) {

    $($(this).find('input.search-terms')).val($($(this).find('input.search-terms')).val() + "*");

  });

  /* */
  $('body').on('click','.jp-checkout', function(e) {
    $(this).parents('.cart_wrap').find('form input[type="submit"]').trigger('click');
  });

  $('body').on('click','.js-continue-shopping', function(e) {
    console.log('fdafdas');
    $(this).parents('.cart_wrap').find('a[title="Close"]').trigger('click');
  });

  window.updateShippinginfo = function(val) {

    var freeShippingthreshold = 9900;
    var priceLeft = freeShippingthreshold - parseInt(val);

    if (val == -1) {
      var shoppingBar = $(document).find('.jp-shipping-bar');

      if (shoppingBar.length > 0) {
        var total = shoppingBar.data('total');
        var value = shoppingBar.data('value');  
        var shoppingBarlength = value.toFixed(2) / total.toFixed(2) * 100;
        shoppingBar.empty().html('<div style="position: absolute; height: 100%; width:' + shoppingBarlength + '%; background-color: rgb(79, 36, 20); left: 0; top: 0;"></div>')
      } 
    } else {
      if (priceLeft > 0) {
        var shippingInfo = $(document).find('#jp-shipping-info');
        shippingInfo.empty().html('<p>You are <strong>' + Shopify.formatMoney(priceLeft)  + '</strong> away from free shipping!</p><div class="jp-button-wrapper">' + '<a href="#" class="js-continue-shopping">Continue Shopping</a>' + '</div><div class="jp-shipping-bar" data-total="9900" data-value="' + val + '"></div>');

        var shoppingBar = $(document).find('.jp-shipping-bar');

        if (shoppingBar.length > 0) {
          var total = shoppingBar.data('total');
          var value = shoppingBar.data('value');  
          var shoppingBarlength = value.toFixed(2) / total.toFixed(2) * 100;
          shoppingBar.empty().html('<div style="position: absolute; height: 100%; width:' + shoppingBarlength + '%; background-color: rgb(79, 36, 20); left: 0; top: 0;"></div>')
        }

      }else {
        var shippingInfo = $(document).find('#jp-shipping-info');
        shippingInfo.empty().html('<p><strong>Congrats!</strong> You\'ve received free standard shipping.</p><div class="jp-button-wrapper">' + '<a href="#" class="js-continue-shopping">Continue Shopping</a>' + '<a href="#" class="jp-checkout">Checkout Now</a>' + '</div>');
      }

      console.log(val);
    }

  }

  window.updateShippinginfo(-1);


  /* Recommended product */
  function ProductRecommendations(container) {
    var $container = (this.$container = $(container));

    var baseUrl = $container.data('baseUrl');
    var productId = $container.data('productId');
    var limit = $container.data('limit');
    var productRecommendationsUrlAndContainerClass = baseUrl + '?section_id=product-recommendations&product_id=' + productId + '&limit=' + limit;
    $container.load(productRecommendationsUrlAndContainerClass);
  }

  ProductRecommendations($('.product-recommendations'));

});

